// extracted by mini-css-extract-plugin
export default {"article":"article-E2hc","embed":"embed-q31b","preloader":"preloader-ZpUD","fadeIn":"fadeIn-BH0e"};